module.exports = __webpack_public_path__ + "static/media/vuforia.e951716b.png";